import { render, staticRenderFns } from "./BaseTLButton.vue?vue&type=template&id=836997d2&"
import script from "./BaseTLButton.vue?vue&type=script&lang=ts&"
export * from "./BaseTLButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports